import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from "../../services/utils/authentication.service";
import { StorageService } from "front-common-toolkits";
import { Router } from "@angular/router";
import { CookieService } from "ngx-cookie-service";
import { SiteService } from 'src/app/services/site.service';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { Store } from "@ngrx/store";
import { AppState } from "src/app/services/state/app.state";
import * as UserActions from "src/app/services/state/actions/user.action";
@Component({
  selector: 'app-login-redirection',
  templateUrl: './login-redirection.component.html',
  styleUrls: ['./login-redirection.component.css']
})
export class LoginRedirectionComponent implements OnInit {

  constructor(
    private router: Router,
    private siteService: SiteService,
    private notification: NzNotificationService,
    private storageService: StorageService,
    private cookieService: CookieService,
    private store:Store<AppState>,
    private authenticationService: AuthenticationService
  ) { }

  ngOnInit(): void {
    this.checkRefreshToken();
  }

  async checkRefreshToken() {
    const refreshToken = this.storageService.getLocalItem('refreshToken');
    console.log('check refresh token');
    if (refreshToken) {
      const isRefreshSuccess = await this.authenticationService.refreshToken(true);
      if (isRefreshSuccess) {
        console.log('token has refreshed');
        // 应该跳转到角色有权限的第一页，非固定页面 20200302 baij
        const menu = await this.siteService.getDefaultLoginMenu()
        if (menu) {
          this.router.navigate([menu.menuUrl]);
        } else {
          this.notification.warning('没有访问页面的权限', '');
          //并跳转页面 
          // not logged in so redirect to login page
          console.log('login-redirection.component.ts  方法checkRefreshToken 401',this.cookieService.get('token'))

          this.store.dispatch(new UserActions.RemoveUser())
          this.cookieService.delete('token');
          this.cookieService.delete('refreshToken');
          this.router.navigate(['/login']);
          return false;
        }

      } else {
        console.log('login-redirection.component.ts  方法checkRefreshToken 402',this.cookieService.get('token'))
        console.log('token has not refreshed');
        this.cookieService.delete('token');
        this.cookieService.delete('refreshToken');
        this.router.navigate(['/login']);
      }
    } else {
      console.log('login-redirection.component.ts  方法checkRefreshToken 403',this.cookieService.get('token'))
      this.router.navigate(['/login']);
    }
  }

}
